import React, {useState} from 'react'
import {ivyLink} from "../../helpers/constants";
import {localize} from "../../helpers/functions";
import {navigate} from "@reach/router";
import {Routes} from "../AppRouter";
import WithAuth from "../../components/HOC/WithAuth";
import Head from "../../components/Head";

const NotFound404 = props => {
    const [keyword, setKeyword] = useState('')

    const _handleKeyDown = (e) => {
        if (e.key === 'Enter' && e.target.value.length > 0) {
            navigate(Routes.searchTo(e.target.value))
        }
    }

    return (
        <>
            {/*<Head title='404'/>*/}

            {/*<div className='error-404-container'>*/}
            {/*    <h1>404</h1>*/}
            {/*    <h5>{localize('error404')}</h5>*/}
            {/*    <img src={ivyLink} alt=""/>*/}
            {/*    <input type="text" className="form-control" placeholder={localize('searchMsg')} value={keyword} onKeyDown={_handleKeyDown}*/}
            {/*           onChange={e => setKeyword(e.target.value)}/>*/}

            {/*</div>*/}
        </>
    )
}

export default WithAuth(NotFound404)
